import EventEmitter from "./event-emitter";

export default class Collapsible extends EventEmitter {
	constructor(props = {}) {
		super(props);

		this.$root = props.$root;
		this.$trigger = null;
		this.$container = null;
		this.$content = null;
		this.opened = false;

		this.TOGGLE_COLLAPSIBLE_EVENT = 'toggleCollapsible';

		this.init();
	}

	init() {
		if (!this.$root) {
			throw new Error('Collapsible: Root element is missing');
		}

		this.$eventTarget = this.$root;
		this.$trigger = this.$root.querySelector('[data-collapsible-trigger]');
		this.$container = this.$root.querySelector('[data-collapsible-container]');
		this.$content = this.$root.querySelector('[data-collapsible-content]');

		this.opened = this.$root.classList.contains('-opened');

		super.init();
		this.addEventListeners();
	}

	addEventListeners() {
		this.$trigger.addEventListener('click', this.handleToggleCollapsible.bind(this));
	}

	handleToggleCollapsible() {
		this.toggleCollapsible();
	}

	toggleCollapsible() {
		if (!this.opened) {
			this.$container.style.maxHeight = this.$content.offsetHeight + 'px';
			this.opened = true;
			this.$root.classList.add('-opened');
		} else {
			this.$container.style.maxHeight = '0px';
			this.opened = false;
			this.$root.classList.remove('-opened');
		}

		this.dispatchEvent(this.TOGGLE_COLLAPSIBLE_EVENT, this.opened);
	}
}